// Preguntas del cuestionario Climaterio Claro
// No incluye interpretación diagnóstica.

export const AGE_RANGES = [
  { id: "35-39", label: "35 a 39 años" },
  { id: "40-44", label: "40 a 44 años" },
  { id: "45-49", label: "45 a 49 años" },
  { id: "50-54", label: "50 a 54 años" },
  { id: "55-60", label: "55 a 60 años" },
  { id: "60+", label: "Más de 60 años" },
  { id: "prefer_not", label: "Prefiero no responder" },
];

export const YES_NO_UNKNOWN = [
  { id: "yes", label: "Sí" },
  { id: "no", label: "No" },
  { id: "unknown", label: "No sé" },
  { id: "prefer_not", label: "Prefiero no responder" },
];

export const MENSTRUAL_QUESTIONS = [
  {
    id: "menstruated_12m",
    text: "¿Has tenido menstruación en los últimos 12 meses?",
    options: YES_NO_UNKNOWN,
  },
  {
    id: "changes_freq",
    text: "¿Has notado cambios en la frecuencia, duración o cantidad de tu menstruación?",
    options: YES_NO_UNKNOWN,
  },
  {
    id: "no_period_12m",
    text: "¿Han pasado 12 meses consecutivos o más sin menstruación?",
    options: YES_NO_UNKNOWN,
  },
];

// Escala 0..3 + prefiero no responder
export const SCALE = [
  { id: 0, label: "Nada", short: "0" },
  { id: 1, label: "Poco", short: "1" },
  { id: 2, label: "Bastante", short: "2" },
  { id: 3, label: "Mucho", short: "3" },
  { id: "prefer_not", label: "Prefiero no responder", short: "—" },
];

export const SYMPTOMS = [
  { id: "bochornos", text: "Bochornos" },
  { id: "sudoracion_nocturna", text: "Sudoración nocturna" },
  { id: "insomnio", text: "Insomnio o mal dormir" },
  { id: "cansancio", text: "Cansancio o fatiga" },
  { id: "irritabilidad", text: "Irritabilidad" },
  { id: "ansiedad", text: "Ansiedad" },
  { id: "tristeza", text: "Tristeza o bajo ánimo" },
  { id: "niebla_mental", text: "Niebla mental o dificultad para concentrarte" },
  { id: "dolores_articulares", text: "Dolores articulares" },
  { id: "palpitaciones", text: "Palpitaciones" },
  { id: "resequedad_vaginal", text: "Resequedad vaginal" },
  { id: "dolor_relaciones", text: "Dolor con las relaciones sexuales" },
  { id: "deseo_sexual", text: "Disminución del deseo sexual" },
  { id: "molestias_urinarias", text: "Molestias urinarias" },
];

export const IMPACT_QUESTIONS = [
  { id: "vida_diaria", text: "¿Cuánto afectan estos síntomas tu vida diaria?" },
  { id: "sueno", text: "¿Cuánto afectan tu sueño?" },
  { id: "trabajo", text: "¿Cuánto afectan tu trabajo o actividades?" },
  { id: "relaciones", text: "¿Cuánto afectan tus relaciones o bienestar emocional?" },
];

export const EMOTIONAL_QUESTIONS = [
  {
    id: "tristeza_desesperanza",
    text: "En las últimas 2 semanas, ¿has sentido tristeza o desesperanza la mayor parte del tiempo?",
  },
  {
    id: "ansiedad_dificil",
    text: "En las últimas 2 semanas, ¿has tenido ansiedad difícil de controlar?",
  },
  {
    id: "hacerse_dano",
    text: "En las últimas 2 semanas, ¿has tenido pensamientos de hacerte daño?",
    critical: true,
  },
];

export const IMMEDIATE_ALERTS = [
  { id: "dolor_pecho", text: "¿Tienes en este momento dolor u opresión en el pecho?" },
  { id: "dificultad_respirar", text: "¿Tienes en este momento dificultad importante para respirar?" },
  { id: "desmayo", text: "¿Has tenido un desmayo reciente?" },
  { id: "sangrado_debilidad", text: "¿Tienes sangrado incontrolable con debilidad?" },
];

export const PRIORITY_ALERTS = [
  {
    id: "sangrado_post_12m",
    text: "¿Has tenido sangrado después de 12 meses consecutivos sin menstruación?",
  },
  {
    id: "sangrado_abundante",
    text: "¿Has tenido sangrado muy abundante, prolongado o que se repite?",
  },
  { id: "bulto_mamario", text: "¿Has notado un bulto nuevo en la mama?" },
  { id: "secrecion_pezon", text: "¿Has notado secreción sanguinolenta por el pezón?" },
  {
    id: "dolor_pelvico",
    text: "¿Tienes dolor pélvico persistente que no cede?",
  },
  {
    id: "perdida_peso",
    text: "¿Has tenido pérdida involuntaria de peso con fiebre o sudoración nocturna nueva?",
  },
];

export const LIFESTYLE_QUESTIONS = {
  sleep_hours: {
    id: "sleep_hours",
    text: "En promedio, ¿cuántas horas duermes por noche?",
    options: [
      { id: "menos_5", label: "Menos de 5 horas" },
      { id: "5_6", label: "5 a 6 horas" },
      { id: "7_8", label: "7 a 8 horas" },
      { id: "mas_8", label: "Más de 8 horas" },
      { id: "prefer_not", label: "Prefiero no responder" },
    ],
  },
  sleep_quality: {
    id: "sleep_quality",
    text: "¿Cómo es la calidad de tu sueño?",
    options: [
      { id: "mala", label: "Mala" },
      { id: "regular", label: "Regular" },
      { id: "buena", label: "Buena" },
      { id: "prefer_not", label: "Prefiero no responder" },
    ],
  },
  activity: {
    id: "activity",
    text: "¿Con qué frecuencia haces actividad física?",
    options: [
      { id: "nunca", label: "Nunca" },
      { id: "poca", label: "1-2 veces por semana" },
      { id: "regular", label: "3-4 veces por semana" },
      { id: "frecuente", label: "5 o más veces por semana" },
      { id: "prefer_not", label: "Prefiero no responder" },
    ],
  },
  strength: {
    id: "strength",
    text: "¿Realizas ejercicios de fuerza (pesas, bandas, resistencia)?",
    options: [
      { id: "no", label: "No" },
      { id: "a_veces", label: "A veces" },
      { id: "regular", label: "Regularmente" },
      { id: "prefer_not", label: "Prefiero no responder" },
    ],
  },
  diet: {
    id: "diet",
    text: "¿Cómo describirías tu alimentación?",
    options: [
      { id: "mala", label: "Poco equilibrada" },
      { id: "regular", label: "Regular" },
      { id: "buena", label: "Equilibrada" },
      { id: "prefer_not", label: "Prefiero no responder" },
    ],
  },
  alcohol: {
    id: "alcohol",
    text: "¿Consumes alcohol?",
    options: [
      { id: "no", label: "No" },
      { id: "ocasional", label: "Ocasionalmente" },
      { id: "frecuente", label: "Frecuentemente" },
      { id: "prefer_not", label: "Prefiero no responder" },
    ],
  },
  nicotine: {
    id: "nicotine",
    text: "¿Consumes nicotina (tabaco, vapeo)?",
    options: [
      { id: "no", label: "No" },
      { id: "ocasional", label: "Ocasionalmente" },
      { id: "diario", label: "Diariamente" },
      { id: "prefer_not", label: "Prefiero no responder" },
    ],
  },
  support: {
    id: "support",
    text: "¿Cuentas con apoyo emocional cercano?",
    options: [
      { id: "no", label: "No" },
      { id: "poco", label: "Poco" },
      { id: "si", label: "Sí" },
      { id: "prefer_not", label: "Prefiero no responder" },
    ],
  },
};

export const MENSTRUAL_LABEL = (answers) => {
  if (answers.no_period_12m === "yes") return "Sin menstruación por 12+ meses";
  if (answers.menstruated_12m === "yes" && answers.changes_freq === "yes")
    return "Menstruación con cambios recientes";
  if (answers.menstruated_12m === "yes") return "Menstruación regular reciente";
  if (answers.menstruated_12m === "no") return "Sin menstruación reciente";
  return "Situación menstrual no especificada";
};
